<template>
  <RouterView />
</template>

<script lang="ts" setup>
definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepsign.title',
  },
})
</script>
